import { RadioButton } from '@bwoty-web/ui-kit';
import FakeUi from '../../shared/loaders/FakeUi';

import './priceMatrixTableLoader.scss';

const PriceMatrixTableLoader = () => {
  return (
    <div className="price-matrix-table-container price-matrix-table--loader">
      <div className="price-matrix-table">
        <div className="price-matrix-table__header-row">
          <div className="price-matrix-table__header">
            <div className="price-matrix-table__header-fake">
              <FakeUi />
            </div>
          </div>
          <div className="price-matrix-table__right-column price-matrix-table__departure-info">
            <div className="price-matrix-table__departure-top-container">
              <div className="price-matrix-table__departure-day">
                <div className="price-matrix-table__departure-day-fake">
                  <FakeUi />
                </div>
              </div>
              <div className="price-matrix-table__departure-weekday-month">
                <div className="price-matrix-table__departure-month">
                  <FakeUi />
                </div>
                <div className="price-matrix-table__departure-weekday">
                  <FakeUi />
                </div>
              </div>
            </div>
            <div className="price-matrix-table__departure-middle-container">
              <div className="price-matrix-table__departure-time">
                <FakeUi />
              </div>
            </div>
            <div className="price-matrix-table__departure-bottom-container">
              <div className="price-matrix-table__flight-info-text">
                <FakeUi />
              </div>
            </div>
          </div>
        </div>
        <div className="price-matrix-table__row price-matrix-table__row--first">
          <div className="price-matrix-table__left-column">
            <RadioButton disabled onChange={() => {}} />
          </div>
          <div className="price-matrix-table__middle-column">
            <div className="price-matrix-table__room-description-loader">
              <FakeUi />
            </div>
          </div>
          <div className="price-matrix-table__right-column">
            <div className="price-matrix-table__price-loader">
              <FakeUi />
            </div>
          </div>
        </div>
      </div>
      <div className="price-matrix-table_price-info-text">
        <div className="price-matrix-table__price-info-text-loader">
          <FakeUi />
        </div>
      </div>
    </div>
  );
};

export default PriceMatrixTableLoader;
